@if(!errorService.details().error)
{
<frame-navbar>
	<ng-content select='div.navbar-content'></ng-content>
</frame-navbar>
<div class="container-fluid user-access">
	<div class="row g-0">
		<frame-menu></frame-menu>

		<div class="main-wrapper" [class.menu-collapsed]='menu.menuCollapsed()'>
			@if(!menu.menuCollapsed()){
			<div class="frame-menu-overlay" (click)="hideMenu()"></div>
			}

			<div class="main">
				<breadcrumb></breadcrumb>
				<ng-content select='div.page-content'></ng-content>
			</div>

			<back-top [position]="200"></back-top>

		</div>
	</div>
</div>
}
